import Cookies from "js-cookie";

/** Parse officeCodes cookie / string into a deduplicated list. */
export const parseOfficeCodes = (value) => {
  const raw = value ?? Cookies.get("officeCodes") ?? "";
  if (!raw) return [];
  return [...new Set(String(raw).split(",").map((s) => s.trim()).filter(Boolean))];
};

/** First office code from cookie — fallback only. */
export const getPrimaryOfficeCode = () => parseOfficeCodes()[0] || "";

/**
 * Resolve a single office code for claim APIs (backend requires one code per request).
 * Priority: explicit single > shipment/claim context > first from cookie list.
 */
export const resolveClaimOfficeCode = ({
  shipmentOfficeCode,
  claimOfficeCode,
  officeCode,
} = {}) => {
  const candidates = [claimOfficeCode, shipmentOfficeCode, officeCode].filter(Boolean);
  for (const candidate of candidates) {
    const parts = parseOfficeCodes(candidate);
    if (parts.length === 1) return parts[0];
    if (parts.length > 1) return parts[0];
    if (candidate && !String(candidate).includes(",")) return String(candidate).trim();
  }
  return getPrimaryOfficeCode();
};

/** Header value for shipment partial-search (supports multiple offices). */
export const getShipmentSearchOfficeHeader = (officeCode) => {
  const codes = parseOfficeCodes(officeCode);
  return codes.length > 0 ? codes.join(",") : officeCode || Cookies.get("officeCodes") || "";
};
